import { render, staticRenderFns } from "./TextAudit.vue?vue&type=template&id=89c71d1c&scoped=true"
import script from "./TextAudit.vue?vue&type=script&lang=js"
export * from "./TextAudit.vue?vue&type=script&lang=js"
import style0 from "./TextAudit.vue?vue&type=style&index=0&id=89c71d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c71d1c",
  null
  
)

export default component.exports